import axios from "axios";
import store from "./store";

const extractTenantId = () => {
    const match = window.location.pathname.split("/").filter(Boolean);
    return match[0] || null;
};

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
});

api.interceptors.request.use(config => {
    const token = localStorage.getItem("authToken");
    
    const tenantId = extractTenantId(); 

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (tenantId) {
        config.headers["X-TenantID"] = tenantId;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

api.interceptors.response.use(response => {
    if (response?.data?.statusCode === 401) {
        store.dispatch("tenantId/logoutUser");
    }
    return response;
}, error => {
    if (error.code === "ECONNABORTED") {
        return Promise.reject("Request timeout. Try again.");
    }
    if (error.code === "ERR_NETWORK") {
      void 0;
    }
    if (error.response) {
        if (error.response.status === 401) {
            store.dispatch("tenantId/logoutUser");
        } else if (error.response.status === 500) {
            store.commit('api/showSnackbar', {
                message: 'API error.',
                color: '#B71C1C',
                timeout: 7000,
            });
        }
    }
    return Promise.reject(error);
});

export default api;
